import { useMemo, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@store';
import { onSearch } from './store/slices/users';
import ColumnUsers from '../../components/common/column/column-users';
import filtersHelper from './helpers/filters-helper';
import { UserDetails } from './types';

import cn from './styles.module.css';

let timeout: NodeJS.Timeout;

const UsersColumn = ({
  isLoading,
}: {
  isLoading: boolean;
}): React.JSX.Element => {
  const dispatch = useAppDispatch();
  const {
    userList: {
      users: {
        users,
        userId,
        filters,
        selectedRoles,
        filters: { search, onlyArchived, roleId },
      },
      confirm: { popupIsOpen },
    },
    administrationDictionaries: { roles },
  } = useAppSelector((state) => state);
  const [searchText, setSearch] = useState(search);

  const onSearchUsers = (value: string) => {
    clearTimeout(timeout);
    setSearch(value);

    timeout = setTimeout(() => {
      dispatch(onSearch(value));
    }, 500);
  };

  const filteredUsers = useMemo(
    () => filtersHelper(users as UserDetails[], filters, selectedRoles),
    [users, search, onlyArchived, roleId, selectedRoles],
  );

  const formattedUsers = useMemo(
    () =>
      filteredUsers?.map((user) => ({
        ...user,
        employeeRoleTemplateName: user.employeeRoleTemplateId
          ? roles?.find((role) => role.value === user.employeeRoleTemplateId)
              ?.name
          : undefined,
      })),
    [filteredUsers, roles],
  );

  return (
    <div className={cn.columnWrapper}>
      <ColumnUsers
        users={formattedUsers}
        isLoading={isLoading}
        userId={userId}
        onSearch={onSearchUsers}
        search={searchText}
        popupIsOpen={popupIsOpen}
        roles={roles}
        selectedRoles={selectedRoles}
        onlyArchived={onlyArchived}
      />
    </div>
  );
};

export default UsersColumn;
